export default __webpack_public_path__ + "static/media/Moderat-Extended-Black.588626cf.ttf";